import { useMutation } from "@tanstack/react-query";
import viewService from "../api/viewService";
export const useCreateView = () => {
  const { createView } = viewService();

  return useMutation({
    mutationKey: ["create-view"],
    mutationFn: async ({ view }) => {
      const response = await createView(view);
      return response.data;
    },
  });
};

export const useUpdateView = () => {
  const { updateView } = viewService();

  return useMutation({
    mutationKey: ["update-view"],
    mutationFn: async ({ view }) => {
      const response = await updateView(view);
      return response.data;
    },
  });
};

export const useUpdateViewOrder = () => {
  const { updateViewOrder } = viewService();

  return useMutation({
    mutationKey: ["update-view-order"],
    mutationFn: async ({ views }) => {
      const response = await updateViewOrder(views);
      return response.data;
    },
  });
};

export const useDeleteView = () => {
  const { deleteView } = viewService();

  return useMutation({
    mutationKey: ["delete-view"],
    mutationFn: async ({ id }) => {
      const response = await deleteView(id);
      return response.data;
    },
  });
};

export const useSaveView = () => {
  const { saveView } = viewService();

  return useMutation({
    mutationKey: ["create-view-filters"],
    mutationFn: async ({
      viewId,
      filters,
      hiddenColumns,
      columnOrder,
      sorts,
    }) => {
      const response = await saveView(viewId, {
        filters,
        hiddenColumns,
        columnOrder,
        sorts,
      });
      return response.data;
    },
    scope: "urmom"
  });
};
